import { render, staticRenderFns } from "./TalkroundInfos.vue?vue&type=template&id=e2ab3860&scoped=true"
import script from "./TalkroundInfos.vue?vue&type=script&lang=js"
export * from "./TalkroundInfos.vue?vue&type=script&lang=js"
import style0 from "./TalkroundInfos.vue?vue&type=style&index=0&id=e2ab3860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ab3860",
  null
  
)

export default component.exports